const EmptyState = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-col justify-center items-center">
      <p className="text-center w-4/5 lg:w-1/2 mb-5">{text}</p>
      <img src="/giphy.webp" width="480" height="270" alt="" />
    </div>
  )
}

export default EmptyState
